/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

/**
 * e: EKis/EParc (the seed source), e_alp: with EAlp, evi: EviKis/EviParc, vi: ViKis/ViParc (same year)
 */
export type HistoryInMethod = typeof HistoryInMethod[keyof typeof HistoryInMethod];


export const HistoryInMethod = {
  e: 'e',
  e_alp: 'e_alp',
  evi: 'evi',
  vi: 'vi',
} as const;
